import { Button, Form, Radio, Space } from 'antd';
import React from 'react';
import { $Formutil, FormItem, withForm } from 'react-antd-formutil';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import BottomBox from 'components/BottomBox';
import Debug from 'components/Debug';
import Toast from 'components/Toast';
import { PlaidBankCardItem } from 'components/vendor/plaid';
import { Source } from 'types/funding';
import { getBankAccountType } from '../AchBank/helper';
import { bindCardStep2 } from './request';
import './style.scss';

interface ChooseBankCardProps {
    $formutil: $Formutil;
    source: Source;
}

const ChooseBankCard: React.FC<ChooseBankCardProps> = ({ $formutil, source }) => {
    const location = useLocation();
    const locationState = location.state as {
        data: {
            items: PlaidBankCardItem[];
            item_id: string;
        };
    } | null;
    const navigate = useNavigate();
    const { $params, $invalid, $batchState } = $formutil;

    const render = () => {
        const { items: cardList, item_id: itemId } = locationState!.data;

        const handleSubmit = async (ev: React.FormEvent<HTMLFormElement>) => {
            if ($invalid) {
                $batchState({
                    $dirty: true,
                    $touched: true
                });
            } else {
                Toast.loading(true);

                try {
                    const { accountId } = $params;
                    const mask = cardList.find(({ account_id: currAccountId }) => currAccountId === accountId)?.mask;
                    const { data } = await bindCardStep2(accountId, itemId, mask);

                    navigate(`/profile/${source}/ach/fill`, {
                        state: data
                    });
                } catch (error) {
                    navigate(`/profile/${source}/ach/complete`, {
                        state: {
                            error_code: error.error_code,
                            type: 'error',
                            source: source
                        }
                    });
                }

                Toast.loading(false);
            }
        };

        return (
            <Form onFinish={handleSubmit}>
                <FormItem name="accountId" required className="choose-card-list">
                    <Radio.Group>
                        <Space direction="vertical">
                            {cardList?.map(item => {
                                const { account_id } = item;

                                return (
                                    <Radio key={account_id} value={account_id}>
                                        <span>{getBankAccountType(item)}</span>
                                    </Radio>
                                );
                            })}
                        </Space>
                    </Radio.Group>
                </FormItem>
                <Debug data={$params} />
                <BottomBox className="btn-box">
                    <Button
                        className="btn-important"
                        htmlType="submit"
                        type="primary"
                        disabled={!$params.accountId}
                        block>
                        {__('Confirm')}
                    </Button>
                </BottomBox>
            </Form>
        );
    };

    if (!locationState) {
        return <Navigate to={`/profile/${source}`} replace />;
    }

    return (
        <div className="choose-bank-card-root">
            <h3 className="main-title">{__('Please Choose the Bank Account you would like to link')}</h3>
            {render()}
        </div>
    );
};

export default withForm(ChooseBankCard);
